<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/TermsAndConditions/Form'

export default {
    name: 'TermsAndConditionCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.terms-and-conditions.store'))
        }
    }
}
</script>
